interface LogoProps {
  className?: string;
}

export function BitcoinTrackerLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M34.5,31.7c0-1.6-.5-3.1-1.6-4.4s-2.4-2.1-4.2-2.3l-1.1-.2,1.1-.3c3.5-1,5.1-2.9,5.1-5.9s-.7-3.8-2.2-5.1c-1-.9-2.3-1.5-3.9-1.8h-.2v-3.7h-2.9v3.4h-4.1v-3.4h-2.9v3.4h-2.1v27.3h2.1v3.2h2.9v-3.2h4.1v3.2h2.9v-3.3h.2c1.8-.3,3.2-.9,4.4-1.9,1.6-1.3,2.4-3,2.4-5h0ZM18.6,13.9h6.4c1.7,0,3.1.4,4.1,1.3s1.5,2.1,1.5,3.5-.5,2.7-1.5,3.5-2.3,1.3-4.1,1.3h-6.4v-9.7h0ZM29.8,35c-1.1.9-2.5,1.3-4.3,1.3h-6.8v-10.4h6.5c1.9,0,3.3.4,4.5,1.3s1.7,2.2,1.7,3.9-.5,2.9-1.6,3.9h0Z" 
      />
    </svg>
  );
}